#@import Booking.Presenters.Base
#@export Booking.Presenters.TextNotifications

class Booking.Presenters.TextNotifications extends Booking.Presenters.Base

  toHash: ->
    tooltipId = 'text-notification'
    reservationId = @model.getReservation()?.id if typeof @model.getReservation is 'function'
    tooltipId = "#{tooltipId}-#{reservationId}" if reservationId?
    checked = @model.getTextNotifications() is 'true'

    schedulingNoun = @getSchedulingNoun {}
    schedulingNounWithDeterminer = @getSchedulingNoun withDeterminer: true

    {tooltipId, checked, schedulingNoun, schedulingNounWithDeterminer}
